// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"EpochGameEndGameModal_modalContent__2vv7v"};